'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$23() {
}
export { $c_Lpresto_CredentialTables$$anon$23 as $c_Lpresto_CredentialTables$$anon$23 };
$p = $c_Lpresto_CredentialTables$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$23;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$23() {
}
export { $h_Lpresto_CredentialTables$$anon$23 as $h_Lpresto_CredentialTables$$anon$23 };
$h_Lpresto_CredentialTables$$anon$23.prototype = $p;
$p.b6 = (function(_$71) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$71, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$72) => _$72.iw.rF)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_math_LowPriorityOrderingImplicits$$anon$2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bL));
});
var $d_Lpresto_CredentialTables$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$23, "presto.CredentialTables$$anon$23", ({
  FH: 1,
  G: 1
}));
export { $d_Lpresto_CredentialTables$$anon$23 as $d_Lpresto_CredentialTables$$anon$23 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$23.js.map
